import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
import ManualPcrTableQueue from "./ManualPcrTableQueue";
import ManualPcrPending from "./ManualPcrPending";
import "./ManualPcrTab.css";

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other} // eslint-disable-line
    >
      {value === index && (
      <Box className="ManualPcrTab__Box">
        {children}
      </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

TabPanel.defaultProps = {
  children: null,
};

const AntTabs = withStyles({
  root: {
    borderBottom: "transparent",
  },
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 40,
      width: "100%",
      backgroundColor: "#494B83",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />); // eslint-disable-line

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    minWidth: 72,
    marginRight: theme.spacing(4),
    fontFamily: "Roboto Bold",
    letterSpacing: "unset",
    fontSize: "16px",
    "&:hover": {
      color: "#494B83",
      opacity: 1,
    },
    "&$selected": {
      color: "#494B83",
      fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: "#494B83",
    },
  },
  selected: {},
}))((props) => <Tab disableRipple {...props} />); // eslint-disable-line

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
  tabStyle: {
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function CustomizedTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.tabStyle}>
        <AntTabs value={value} onChange={handleChange} aria-label="ant example">
          <AntTab label="Queue" />
          <AntTab label="Pending" />
        </AntTabs>
        <TabPanel value={value} index={0}>
          <ManualPcrTableQueue />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ManualPcrPending />
        </TabPanel>
      </div>
    </div>
  );
}
